export enum TriggersRoutes {
  root = 'triggers',
  all = 'all',
  sms = 'sms',
  ringless = 'ringless',
  rcs = 'rcs',
  create = 'create',
  edit = 'edit',
  clone = 'clone',
  view = 'view',
}
